import type { TourStep } from '../types';
export const designerThemeTaskSteps: TourStep[] = [
  { target: '[data-tour="designer-theme-status"]', title: 'Статус задания', content: 'Статус показывает текущий этап работы над заданием.' },
  { target: '[data-tour="designer-theme-tabs"]', title: 'Разделы задания', content: 'Переключайтесь между заданием и загрузкой макетов.' },
  { target: '[data-tour="designer-theme-task"]', title: 'Что нужно сделать', content: 'Сверяйтесь с требованиями перед подготовкой файлов.' },
];
